var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-content-tabs"},[_c('ul',{style:(_vm.contentTabFixed ? 'position:fixed;top:0;z-index:1;' : '')},_vm._l((_vm.tabInfo),function(tab,index){return _c('li',{key:tab.id,class:{ 'tab--active': tab.show },on:{"click":function($event){return _vm.changeTab(tab, index, $event)}}},[_c('span',[_vm._v(_vm._s(tab.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ed2fb8","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewCourseDetail/modules/DetailContent.vue
// module id = 1045
// module chunks = 1